import axios from "axios";
import api from "./api";
import { apiOrigin } from "./apiOrigin";
import { AuthUser } from "../components/user/userTypes";
export interface ILoginValues {
  password: string;
  email: string;
}

const Axios = axios.create({
  baseURL: apiOrigin,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

Axios.defaults.withCredentials = true;

/**
 * Laravel will not accept a POST until the browser holds this cookie. It is served by the
 * application rather than the API, so it is fetched off the root instead of through `api`.
 */
export const csrfCookie = () => Axios.get(`sanctum/csrf-cookie`);

export const login = (
  values: ILoginValues,
): Promise<
  | AuthUser
  | { two_factor: boolean }
  | { two_factor_required: boolean; two_factor_organisation: string }
> => {
  return csrfCookie()
    .then(() => api.post(`/auth/login`, values))
    .then(({ data }) => {
      return data.data;
    });
};

export const register = (values: any) => {
  return null;
};

export const getUser = () => api.get("/me").then(({ data }) => data.data);

export const logout = () => api.post("/logout");
